"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = void 0;
const GeoLine_1 = require("./GeoLine");
const debug = process.env.REACT_APP_DEBUG && false;
const typeName = 'Path';
class Path extends GeoLine_1.GeoLine {
    constructor(ob) {
        super({ ...ob, type: ob.type ?? typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'identification' },
            description: { type: 'String', editable: true, label: 'Description', description: 'description' },
        };
    }
}
exports.Path = Path;
